import { hotList } from '@/mocks/home';

const TREND_MAP: Record<string, { icon: string; className: string; label: string }> = {
  up: { icon: 'ri-arrow-up-line', className: 'text-primary-500', label: '上升' },
  down: { icon: 'ri-arrow-down-line', className: 'text-secondary-500', label: '回落' },
  flat: { icon: 'ri-subtract-line', className: 'text-foreground-400', label: '持平' },
};

function formatHeat(heat: number) {
  if (heat >= 10000) {
    return `${(heat / 10000).toFixed(1)} 万`;
  }
  return `${heat}`;
}

export default function HotListSection() {
  const [lead, ...rest] = hotList;

  return (
    <section id="hot" className="bg-background-100 paper-grain py-14 md:py-20">
      <div className="mx-auto max-w-8xl px-4 md:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.2em] text-primary-600">
              <i className="ri-fire-line"></i>
              WEEKLY RANKING
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              本周深扒榜
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              根据站内阅读、收藏与讨论热度综合排序，每日刷新一次。榜单只反映关注度，不代表事件结论。
            </p>
          </div>
          <span className="inline-flex shrink-0 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-4 py-2 text-xs text-foreground-600">
            <i className="ri-refresh-line text-primary-500"></i>
            更新于 09-10 08:00
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="lg:col-span-7">
            <a
              href="#articles"
              className="group flex h-full flex-col justify-between rounded-lg border border-background-300/70 bg-background-50 p-6 transition-colors hover:border-primary-300 md:p-8"
            >
              <div>
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                    01
                  </span>
                  <span className="rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-800">
                    {lead.category}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-xl font-bold leading-snug text-foreground-950 group-hover:text-primary-600 md:text-3xl">
                  {lead.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                  本期榜首。我们从素材比例、节奏点与情绪线三个层面，复盘这档综艺的叙事是怎么被组装出来的。
                </p>
              </div>
              <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 border-t border-background-200 pt-5 text-xs text-foreground-500 md:text-sm">
                <span className="inline-flex items-center gap-2">
                  <i className="ri-fire-fill text-primary-500"></i>
                  热度 {formatHeat(lead.heat)}
                </span>
                <span className="inline-flex items-center gap-2">
                  <i className="ri-arrow-up-line text-primary-500"></i>
                  较昨日上升
                </span>
                <span className="ml-auto inline-flex items-center gap-1 font-medium text-primary-600">
                  阅读全文
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </a>
          </article>

          <ol className="flex flex-col gap-3 lg:col-span-5">
            {rest.map((item) => {
              const trend = TREND_MAP[item.trend] ?? TREND_MAP.flat;
              return (
                <li key={item.id}>
                  <a
                    href="#articles"
                    className="group flex items-center gap-4 rounded-lg border border-background-300/60 bg-background-50 px-4 py-3.5 transition-colors hover:border-accent-400"
                  >
                    <span
                      className={`font-heading text-lg font-bold ${
                        item.rank <= 3 ? 'text-primary-500' : 'text-foreground-300'
                      }`}
                    >
                      {String(item.rank).padStart(2, '0')}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-sm font-medium text-foreground-900 group-hover:text-primary-600">
                        {item.title}
                      </span>
                      <span className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                        <span>{item.category}</span>
                        <span className="inline-flex items-center gap-1">
                          <i className="ri-fire-fill text-accent-500"></i>
                          {formatHeat(item.heat)}
                        </span>
                      </span>
                    </span>
                    <span className={`flex items-center ${trend.className}`} title={trend.label}>
                      <i className={trend.icon}></i>
                    </span>
                  </a>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}